import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Tue Jul 16 2019
 * @author Tomáš Leity
 */
import * as React from 'react';
import AccordionStyled from './styled/AccordionStyled';

var Accordion =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Accordion, _React$Component);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Accordion).call(this, props));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getInitialState = _this.getInitialState.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = Object.assign({}, _this.getInitialState());
    return _this;
  }
  /**
   * Get initial state
   */


  _createClass(Accordion, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this2 = this;

      var state = {};
      React.Children.forEach(this.props.children, function (child) {
        if (React.isValidElement(child)) {
          state[child.props.id] = _this2.props.openAll || child.props.isOpen || false;
        }
      });
      return state;
    }
    /**
     * Open / Hide accordion section
     * @param id
     */

  }, {
    key: "onClick",
    value: function onClick(id) {
      var _this3 = this;

      return function () {
        _this3.setState(_defineProperty({}, id, !_this3.state[id]));
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return React.createElement(AccordionStyled, {
        className: "accordion".concat(className ? " ".concat(className) : '')
      }, React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, Object.assign(Object.assign({}, child.props), {
            isOpen: _this4.state[child.props.id],
            onClick: _this4.onClick(child.props.id)
          }));
        }

        return null;
      }));
    }
  }]);

  return Accordion;
}(React.Component);

export default Accordion;